<!-- eslint-disable no-irregular-whitespace -->
<template>
  <div class="Information min-h-50">
    <div class="border borderColordarkgray2 rounded overflow-hidden tracking-wider">
      <div class="service">
        <div class="contact-body px-4 md:px-10 py-6 md:py-8">
          <h4 class="mb-4 text-NotoSansRegular font-bold">公司資訊</h4>
          <div class="text-NotoSansRegular mt-4">
            <p>公司名稱：希伯崙股份有限公司</p>
            <p>統一編號：16161396</p>
            <p>客服電話：02-25787838</p>
            <p>營業時間：週一至週五 8:30~17:30（例假日暫不提供電話服務）</p>
            <p>登記地址：105台北市松山區八德路三段32號12樓</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Information',
  data () {
    return {
      email: ''
    }
  },
  components: {
  },
  mixins: [
  ],
  computed: {
  },
  mounted () {
  },
  updated () {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
</style>
